<template>
  <component :is="forms[step]" :csrf="csrf" :uid="uid" :values="values" @go-step="goStep($event)" />
</template>

<script>
import orderFormsNologinCreateForm from './order-forms-nologin-create-form.vue';
import orderFormsNologinCreateConfirm from './order-forms-nologin-create-confirm.vue';

export default {
  data: function () {
    return {
      forms: {
        step1: 'orderFormsNologinCreateForm',
        step2: 'orderFormsNologinCreateConfirm',
      },
      //
      step: 'step1',
      uid: 0,
    };
  },
  props: {
    csrf: {
      type: String,
      default: '',
    },
    values: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  components: {
    orderFormsNologinCreateForm,
    orderFormsNologinCreateConfirm,
  },
  methods: {
    goStep(event) {
      switch (event.step) {
        // заполнить форму
        case 'step1':
          //
          break;
        // подтвердить
        case 'step2':
          //
          break;
      }

      this.step = event.step;

      this.uid = event.uid;
    },
  },
};
</script>
